import React, { useState, useRef } from 'react';
import useFetchRoomData from '../hooks/useFetchRoomData';
import Room from './Room';

const floorPlans = {
    1: '/epb_home_1f.jpg',
    2: '/epb_home_2f.jpg',
    3: '/epb_home_3f.jpg',
    4: '/epb_home_4f.jpg',
};

const FloorMap = ({ floor }) => {
    const { rooms } = useFetchRoomData(floor);
    const [activeRoom, setActiveRoom] = useState(null);
    const containerRef = useRef(null);

    const allRooms = [...(rooms?.WarnRooms ?? []), ...(rooms?.Rooms ?? [])];

    const handleRoomClick = (e, room) => {
        e.stopPropagation();
        setActiveRoom((prev) => (prev?.id === room.id ? null : room));
    };

    const handleContainerClick = () => {
        setActiveRoom(null);
    };

    return (
        <div className="content">
            <div
                ref={containerRef}
                className={`floor-plan-container floor-${floor}`}
                onClick={handleContainerClick}
            >
                <img
                    src={floorPlans[floor]}
                    alt={`Floor ${floor} Plan`}
                    style={{ width: '100%' }}
                />
                {allRooms.map((room) => (
                    <div
                        key={room.id}
                        className={`room ${room.is_temp_warning || room.is_humidity_warning ? 'room_warning' : 'room_success'}`}
                        onClick={(e) => handleRoomClick(e, room)}
                        style={{ top: `${room.y}%`, left: `${room.x}%` }}
                    />
                ))}
                {activeRoom && (
                    <div
                        className="room-tooltip"
                        style={{ top: `${activeRoom.y}%`, left: `${activeRoom.x}%` }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Room {...activeRoom} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default FloorMap;
